import * as React from "react";
import UserData from "../../../../model/user/UserData";
import {BaseFormViewState, default as BaseFormView} from "../../../ui/form/BaseFormView";
import UserForm from "../UserForm";
import FormButtonsView from "../../../ui/form/FormButtonsView";
import UserFormBody from "../UserFormBody";
import User from "../../../../model/user/User";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";

interface IComponentProps {
	/**
	 * On submit callback. Should call only when form is valid.
	 * @param {UserData} data new organisation user data.
	 * @param {string} password new user password.
	 * @param {boolean} disabled user status
	 */
	onSubmit: (data: UserData, password: string, disabled: boolean) => void;
	/**
	 * On cancel button handler.
	 */
	onCancel: () => void;
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * User to edit
	 */
	user: User;
	/**
	 * On add file
	 */
	onAddFile: (file: File) => any
	/**
	 * On remove file
	 */
	onRemoveFile: () => any
}

type IState = BaseFormViewState<UserForm>;

export default class EditUserFormView extends BaseFormView<UserForm, IComponentProps, IState> {
	constructor(props: IComponentProps) {
		super(props);
		this.state = {
			form: UserForm.createFromUser(props.user.data, props.user.disabled),
			isFormDirty: false,
			shouldValidate: false
		};
	}

	render() {
		return (
			<div>
				<UserFormBody form={this.state.form}
							  onFieldChange={this.onFieldChanged}
							  onFieldCompleted={this.onFieldCompleted}
							  onFocusChange={this.onFocusChange}
							  usernameDisabled
							  onRemoveFile={this.props.onRemoveFile}
							  onAddFile={this.props.onAddFile}
							  onFieldsChange={this.onFieldsChanged}
							  editMode={true}
							  user={this.props.user}/>
				<FormButtonsView align={"right"}>
					<ButtonTertiary onClick={this.props.onCancel}
									label={"Cancel"}
									disabled={this.props.isSubmitting}/>
					<ButtonPrimary onClick={() => this.submitForm()}
								   label={"Update User"}
								   disabled={this.props.isSubmitting}
								   isLoading={this.props.isSubmitting}/>
				</FormButtonsView>
			</div>
		);
	}

	submitForm(): void {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onValid(this.props.onSubmit);
		});
	}
}